import { TCache } from "./TCache";
export class GeometryCache extends TCache {
    constructor(tilingScheme) {
        super(tilingScheme);
    }
    /**
     * This function will evict the cached data for the given tile. If there is no cache entry for the tile then the
     * function will just do nothing.
     * @param x The x coordinate of the tile to evict
     * @param y The y coordinate of the tile to evict
     * @param zoomLevel The zoom level we're looking up a tile to evict
     */
    release(x, y, zoomLevel) {
        super.release(x, y, zoomLevel, (v) => {
            v.forEach((z) => z.geometry.dispose());
        });
    }
}
